var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cb-floatingBtn pr-5",attrs:{"id":"cb-floatingBtn"}},[_c('vs-button',{staticClass:"py-2",attrs:{"color":"secondary"}},[_vm._v("Help")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }